class CopyRightElement extends HTMLElement {
  static get observedAttributes() {
    return ['founded', 'icon-only'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'founded') {
      this.founded = newValue;
    }
    this.template();
  }

  connectedCallback() {
    // Capture the light DOM content before templating
    this._content = this.textContent;
    this.template();
  }

  disconnectedCallback() {}

  set founded(newFounded) {
    const nf = parseInt(newFounded);
    if (nf && nf < this.year) {
      this._founded = nf;
    } else {
      this._founded = undefined;
    }
    this.template();
  }

  get founded() {
    return this._founded;
  }

  get year() {
    return new Date().getFullYear();
  }

  get yearString() {
    if (this.founded && this.founded !== '') {
      return `${this.founded}-${this.year.toString()}`;
    } else {
      return this.year.toString();
    }
  }

  get _template() {
    return `${this.iconOnlyText}© ${this.yearString} <slot></slot>`;
  }

  template() {
    this.shadowRoot.innerHTML = this._template;
  }

  get iconOnly() {
    return this.hasAttribute('icon-only');
  }

  get iconOnlyText() {
    if (this.iconOnly) {
      return '';
    } else {
      return 'Copyright ';
    }
  }
}

export { CopyRightElement };
